<template>
<div class="login__recover">
  <img :src="require('@/assets/img/logo-bluebox.svg')" alt="Logo BlueBox">
  <div class="subtitle">Le enviaremos un enlace para restablecer su contraseña</div>
  <form class="recover" @submit.prevent="recover">
    <input type="text" name="" id=""
      placeholder="Ingrese su correo o DNI"
      v-model="creds.email"
      :class="{'input-error': errorLog}">

    <div class="init-session" @click="$emit('initSession')">Iniciar sesión</div>
    <button class="btn-scale" >
      <span v-if="!loading">Restablecer contraseña</span>
      <Loader v-else spin-ext="#fff" spin-int="white"/>
    </button>
  </form>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import Loader from '@/components/Loaderic'
import { setTimeout } from 'timers';

export default {
  components: {
    Loader,
  },
  data() {
    return {
      creds: {
        email: null
      },
      loading: false,
      errorLog: false
    }
  },
  methods: {
    ...mapActions({
      recoveryPass: 'recoveryPass'
    }),

    recover(){
      this.loading = true
      console.log(this.creds);
      this.recoveryPass(this.creds).then((r) => {
        this.loading = false
        this.errorLog = false
        this.$toasted.success(`${r.detail}`, { 
          theme: "bubble", 
          position: "top-left", 
          duration : 5000,
          className: 'short-message'

        })
        console.log(r)
        setTimeout(() => {
          this.$emit('initSession')
        }, 1000)
        }, (error) => {
          console.log("EL ERROR ES: ", error)
          this.loading = false
          this.errorLog = true
          this.$toasted.show('Correo electrónico no asociado', { 
            theme: "bubble", 
            position: "top-left", 
            duration : 5000,
          })
        })
    }
  }
}
</script>

<style lang="scss">
.short-message{
  max-width: 30rem !important;
  padding: 1rem !important;
  text-align: center;
}
</style>


<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}
.login__recover{
  width: 75%;
  @include mq($lg){
    width: 21rem
  }
  img{
    width: 80%;
    display: block;
    margin: 1rem auto;
  }
  .subtitle{
    text-align: center;
    font-size: .89rem;
    line-height: 1.2rem;
  }
  .recover{
    margin: 2rem auto;
    &>*{display: block}
    input[type="text"]{
      padding-left: .5rem;
      width: 100%;
      height: 3rem;
      border-bottom: 1px solid #E9E9F0;
      margin-bottom: 1rem
    }
    .init-session{
      text-align: right;
      font-size: .75rem;
      color: $b-orange;
      @include mq($md){
        cursor: pointer;

      }
    }
    button{
      display: block;
      margin-top: 2rem;
      background-color: $b-orange;
      width: 100%;
      color: #fff;
      height: 3rem;
      border-radius: .3rem;
    }
  }
}

.input-error{
  border-bottom: 1px solid red !important;
}
</style>
